<template>
  <div>
    <div class="form">
      <div class="form-tabs h-outer-border around-4 bw2 bz0 h-bg brown-2">
        <button v-click-sound-button
                class="tab h-btn ADOPB2ON"
                :class="{ active: item.value === activeTab }"
                v-for="item in tabs"
                @click="activeTab=item.value">
          {{ item.text }}
        </button>
      </div>

      <div class="form-body h-outer-border around-4 bw4 bz0 h-bg brown-2">
        <Skills v-show="activeTab === 'skills'"
                ref="skills"
                :initPrimarySkills="initPrimarySkills"
                :initSecondarySkills="initSecondarySkills">
        </Skills>
        <Spells v-show="activeTab === 'spells'" :initSpells="initSpells" :wisdomLevel="wisdomLevel" ref="spells" :initData="initSpells"></Spells>

        <template v-if="troops">
          <Troops v-show="activeTab === 'troops'" ref="troops"></Troops>
        </template>
      </div>
    </div>

    <footer class="flex justify-center">
      <button v-click-sound-button class="h-btn primary btn-border mr-20" @click="handleSave">保存配置</button>
      <!--<button v-click-sound-button class="h-btn normal btn-border" title="使用当前配置，不做保存" @click="handleApply">使用</button>-->
      <button v-click-sound-button class="h-btn primary btn-border" @click="handleClose">返回</button>
    </footer>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import API from '@js/api'
  import Skills from './skills'
  import Spells from './spells'
  import Troops from './troops'

  export default {
    name: 'panel-list',

    beforeDestroy () {
      this.resetTroops()
    },

    data () {
      return {
        tabs: [
          {
            text: '属性技能',
            value: 'skills',
          },
          {
            text: '英雄魔法',
            value: 'spells',
          },
          {
            text: '英雄部队',
            value: 'troops',
          },
        ],
        activeTab: 'skills',
        configEditShow: false,
        saveLoading: false,

        initPrimarySkills: null,
        initSecondarySkills: null,
        initSpells: null,
        initTroops: null,

        wisdomLevel: 0,
      }
    },

    props: {
      editData: {
        type: Object,
        default () {
          return null
        }
      }
    },

    watch: {
      activeTab (val) {
        if (val === 'spells') {
          const secondarySkills = this.$refs.skills.getSecondarySkills()
          const wisdom = secondarySkills.find((d) => d.name === 'Wisdom')
          this.wisdomLevel = wisdom?.level || 0
        }
      }
    },

    computed: {
      ...mapState('freeConfig', [
        'troops',
      ])
    },

    mounted () {
      if (this.editData) {
        const config = JSON.parse(this.editData.config)
        this.initPrimarySkills = config.ps
        this.initSecondarySkills = config.ss
        this.initSpells = config.sp
        this.initTroops = config.tr
        this.setTroops(config.tr)
      } else {
        this.setTroops()
      }
    },

    methods: {
      ...mapMutations('freeConfig', [
        'setTroops',
        'resetTroops',
      ]),

      handleBuildConfig () {
        this.configEditShow = true
      },

      getFormConfig () {
        const primarySkills = this.$refs.skills.getPrimarySkills()
        const secondarySkills = this.$refs.skills.getSecondarySkills()
        const spells = this.$refs.spells.getSpells()
        const troops = this.troops

        const ps = {
          a: primarySkills.attack,
          d: primarySkills.defense,
          p: primarySkills.power,
          k: primarySkills.knowledge,
        }

        const ss = secondarySkills.filter((d) => d.level).map((d) => {
          return { [d.name]: d.level }
        })

        const sp = spells.map((d) => d.list.filter((d) => d.select)).flat().map((d) => d.name)

        const tr = troops.map((d) => {
          return d.creatureName && d.amount ? { [d.creatureName]: d.amount } : {}
        })
        const isEmptyTroop = tr.every((d) => {
          return !Object.keys(d).length
        })

        if (isEmptyTroop) {
          this.$message('未配置英雄部队')
          return
        }

        const config = {
          id: null,
          title: '临时配置',
          ps,
          ss,
          sp,
          tr,
        }
        return config
      },

      async handleSave () {
        try {
          this.saveLoading = true
          const config = this.getFormConfig()
          if (!config) {
            return
          }
          const title = await this.$confirm(`保存配置`, {
            input: true,
            value: this.editData?.title || '',
            maxLength: 16,
            placeholder: '填写配置标题，最多16个字符',
            validator (content) {
              if (!content.trim()) {
                return new Error('请填写标题')
              }
              if (content.trim().length > 16) {
                return new Error('最多16个字符')
              }
            }
          })

          if (!title) {
            return
          }

          let func = API.pkConfig.addFreeModeConfig
          if (this.editData?.id) {
            func = API.pkConfig.updateFreeModeConfig
          }

          await func({
            id: this.editData?.id || null,
            title: (title || '').trim(),
            config: JSON.stringify({
              ps: config.ps,
              ss: config.ss,
              sp: config.sp,
              tr: config.tr,
            }),
          })
          this.$message('配置已保存')
          this.handleClose()
        } catch (err) {
          this.$message(err)
        } finally {
          this.saveLoading = false
        }
      },

      handleApply () {
        const config = this.getFormConfig()
        if (!config) {
          return
        }
        this.$emit('apply', config)
      },

      handleClose () {
        this.$emit('close')
      },
    },

    components: {
      Skills,
      Spells,
      Troops,
    },

  }
</script>

<style lang="stylus" scoped>
  .form-tabs
    display flex
    padding 3px
    .h-btn
      goldText1()
      margin-right 5px
      width 70px
      height 30px
      font-size 12px
      letter-spacing 2px
      filter grayscale(0.75)
      &:hover
        filter grayscale(0.5)
      &.active
        filter grayscale(0)

  .form-body
    margin-top 5px
    padding 8px

  .config-form
    display flex
    .form-col
      width 332px
      &:not(:last-child)
        margin-right 6px

  footer
    position absolute
    width calc(100% - 30px)
    left 15px
    bottom 20px
    .h-btn
      width 150px
      height 36px
      line-height 32px
      font-size 16px
      font-weight bold
      text-shadow 1px 1px 0 #fff

</style>
